import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { getBexApiContext } from 'bernie-context';
import { ErrorBoundary } from 'bernie-view';
import { RequestOptions } from 'bernie-graphql';
import { NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkPageLoader } from 'uitk-react-loader';

import { PrimaryButtonTracked } from 'components/shared';
import { ListingsStore } from 'stores';
import { useStores } from 'utility/hooks';
import { trackAnalytics, trackAnalyticsList } from 'utility/analytics';

export const ShowMoreButton = observer(() => {
  const { analytics, searchCriteriaStore, searchResults, listingsStore, context: contextStore } = useStores();
  const { listingsAction } = listingsStore;

  const updateListings = async () => {
    try {
      const context = getBexApiContext(contextStore);
      const searchVariables = { context, ...searchCriteriaStore.searchCriteria };
      const requestOptions: RequestOptions = {
        pageId: searchCriteriaStore.pageId,
        extraHeaders: { 'Device-User-Agent-ID': contextStore && contextStore.deviceId }
      };

      const { listingResult } = (await searchResults.fetchResults(searchVariables, requestOptions, analytics)) || {};
      if (listingResult) {
        const showMoreListingsStore = new ListingsStore(listingResult, NOOP_LOGGER);
        listingsStore.updateStoreListings(showMoreListingsStore);
      }
    } catch (error) {
      NOOP_LOGGER.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVERROR'), error);
    }
    listingsStore.showMoreLoading = false;
  };

  const showMoreButtonOnClick = (e: MouseEvent) => {
    e.preventDefault();
    listingsStore.showMoreLoading = true;
    searchCriteriaStore.syncWithListingStore(listingsStore);
    trackAnalyticsList(listingsAction.analyticsList, analytics);
    updateListings();
  };

  useEffect(() => {
    listingsAction.displayAnalytics && trackAnalytics(listingsAction.displayAnalytics, analytics);
  }, [listingsAction.displayAnalytics, analytics]);

  return (
    <ErrorBoundary label="flights.search.showMoreResultsButton">
      <section
        className="uitk-cell uitk-type-center all-t-margin-three all-b-margin-six"
        data-test-id="show-more-section"
      >
        <PrimaryButtonTracked
          disabled={listingsStore.showMoreLoading}
          name="showMoreButton"
          text={listingsAction.displayAction}
          size={UitkButtonSize.SMALL}
          onClick={showMoreButtonOnClick}
          data-test-id="show-more-button"
          aria-label={listingsAction.accessibilityMessage}
        />
        <UitkPageLoader visible={listingsStore.showMoreLoading} />
      </section>
    </ErrorBoundary>
  );
});
